import { Box, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/HighlightOffRounded';
import { fetchUrl } from '@src/reducers/urlPreview';
import { getUrlData } from '@src/selectors/urlPreview';
import { TimelineEvent } from '@src/types';
import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.css';

export type LinkPreviewProps = {
  url: string;
  width?: string;
  titleColor?: string;
  showButton?: boolean;
  onClosePreview?: () => void;
};

export const ChatMessageUrlPrewiewWrapper: React.FC<{
  message: Partial<TimelineEvent>;
  isIncomingMsg?: boolean;
}> = ({ message, isIncomingMsg = false }) => {
  const dispatch = useDispatch();
  const { text } = message;

  useEffect(() => {
    dispatch(fetchUrl({ url: text || '' }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  return (
    <LinkPreview
      url={text || ''}
      width="200px"
      titleColor={isIncomingMsg ? '#000' : '#FFF'}
    />
  );
};

// Stable default identity across renders (same guarantee defaultProps gave).
const noopClosePreview = () => null;

const LinkPreview: React.FC<LinkPreviewProps> = ({
  url,
  width = 'auto',
  titleColor = '#000',
  showButton = false,
  onClosePreview = noopClosePreview,
}) => {
  const urlOnly = url.trim().split(' ')[0];
  const item = useSelector(getUrlData(urlOnly));
  let shortUrl = urlOnly.replace('https://', '');
  shortUrl = shortUrl.replace('http://', '');
  if (shortUrl.slice(-1) === '/') shortUrl = shortUrl.slice(0, -1);

  return (
    <Box className="link-preview-main">
      <Box display="flex">
        <img
          className="link-preview-img"
          alt={item.title}
          src={item.urlImage}
        />
        <div className="link-preview-description" style={{ width }}>
          <div
            className="ellipsis-one-line"
            style={{ color: titleColor }}
            title={item.title}
          >
            <span className="link-preview-title-text">{item.title}</span>
          </div>
          <div
            className="link-preview-description-text ellipsis-three-lines"
            title={item.description}
          >
            {item.description}
          </div>

          <Box
            mt={!isEmpty(item.title) ? 1 : 0}
            minHeight={20}
            className="ellipsis-one-line"
          >
            <a
              className="link-preview-a"
              href={urlOnly}
              rel="noreferrer"
              target="_blank"
            >
              {shortUrl}
            </a>
          </Box>
        </div>
      </Box>
      {showButton && (
        <IconButton
          color="primary"
          component="span"
          onClick={onClosePreview}
          className="link-preview-button"
        >
          <CloseIcon color="primary" />
        </IconButton>
      )}
    </Box>
  );
};

export default LinkPreview;
